import Datagent from "datagent";
import {respondData,requestHandle} from "../utils";

const {filter, format, getField, awaitTo} = Datagent.Hooks;

import Fecha from '../utils/type/Fecha';
import {defaults} from "datagent/src/utils";

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name = "targetData";
const Model = Datagent.Model({
    name,
    fields: {
    },
    methods: {
        firstTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/firstTarget`,params)
        },
        secondTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/secondTarget`,params)
        },
        export(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            if(typeof type === 'undefined') throw new Error('The type params must be have! use "firstTarget"')
            return this.remote(origin).get(`${this._url}/${type}/export`, query)
        },
        /**
         * 榜单数据录入情况
         *
         * fields: {
         *    'stockCode'         : { type: String, default: '' }, // 股票代码
         *    'industryId'        : { type: String, default: '' }, //行业id
         *    'year'              : { type: String, default: '' }, // 年份
         *    'inputStatus'       : { type: Number, default: 0 }, // 录入状况
         *    'editor'            : { type: String, default: '' }, // 录入人
         *    'reviewer'          : { type: String, default: '' }, // 审核人
         *    'abbreviation'      : { type: String, default: '' }, // 公司名称
         *    'socialInputRate'   : { type: Number, default: 0 }, // 社报录入完成度
         *    'yearInputRate'     : { type: Number, default: 0 }, // 年报录入完成度
         *  },
         */
        inputStatus(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/inputStatus`,params)
        },
        /**
         * 数据传递接口
         *
         * @param {*} params
         * @param {number} params.year 项目年
         * @param {number} params.fromIndustryId 原行业
         * @param {number} params.toIndustryId 目标行业
         * @param {array<number>} params.deliverTypeList 传递类型列表，多选，0-年报；1-社报；3-负面行为
         * @param {*} opts
         * @returns
         */
        delivery(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).post(`${this._url}/delivery`,params)
        }
    },
    hooks: {
        fetch: { after: [respondData(), requestHandle(), getField("data", format())] },
        firstTarget: { after: [respondData(), requestHandle()] },
        secondTarget: { after: [respondData(), requestHandle()] },
        export: { after: [respondData(), requestHandle()] },
        inputStatus: { after: [respondData(), requestHandle()] },
        delivery: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
export default Model;
